import { gql } from 'apollo-boost';

export const retargetingConditions = gql`
    query RetargetingConditionsQuery(
        $login: String!
        $input: GdRetargetingConditionsContainerInput!
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            retargetingConditions(input: $input) {
                rowset {
                    name
                    description
                    retargetingConditionId
                }
            }
        }
    }
`;

export const retargetingGoals = gql`
    query RetargetingGoalsQuery(
        $login: String!
        $input: GdGoalsContainerInput!
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            goals(input: $input) {
                rowset {
                    id
                    domain
                    type
                    name
                    counterId
                    subtype
                    uploadingSourceId
                }
            }
        }
    }
`;

export const retargetingConditionEstimation = gql`
    query RetargetingConditionEstimationQuery(
        $input: GdEstimateRetargetingConditionContainerInput!
    ) {
        reqId: getReqId
        estimateRetargetingCondition(input: $input) {
            estimation
            validationResult {
                errors {
                    code
                }
            }
        }
    }
`;

export const retargetingConditionsQueryForGroupEdit = gql`
    query RetargetingConditionsQueryForGroupEdit(
        $login: String!
        $retargetingConditionsInput: GdRetargetingConditionsContainerInput!
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            chiefLogin
            retargetingConditions(input: $retargetingConditionsInput) {
                rowset {
                    name
                    description
                    retargetingConditionId
                    availableForRetargeting
                    goalsInfo {
                        goalDomains
                        hasGeoSegments
                        hasUnavailableGoals
                    }
                    campaigns {
                        id
                        name
                    }
                    conditionRules {
                        goals {
                            id
                            time
                            type
                        }
                        type
                    }
                }
            }
        }
    }
`;

export const retargetingConditionsQueryForCampaignsEdit = gql`
    query RetargetingConditionsQueryForCampaignsEdit(
        $login: String!
        $retargetingConditionsInput: GdRetargetingConditionsContainerInput!
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            retargetingConditions(input: $retargetingConditionsInput) {
                rowset {
                    name
                    retargetingConditionId
                }
            }
        }
    }
`;

export const retargetingConditionsQueryForUserProfile = gql`
    query RetargetingConditionsQueryForUserProfile(
        $login: String!
        $retargetingConditionsInput: GdRetargetingConditionsContainerInput!
    ) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            chiefLogin
            retargetingConditions(input: $retargetingConditionsInput) {
                rowset {
                    name
                    retargetingConditionId
                    adGroupIds
                    conditionRules {
                        interestType
                        goals {
                            id
                            time
                            type
                        }
                        type
                    }
                }
            }
        }
    }
`;
